import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { HiMiniUserGroup } from "react-icons/hi2";
import { FaBars, FaSignOutAlt } from "react-icons/fa";
import { GrAnnounce } from "react-icons/gr";
import { MdSpaceDashboard } from "react-icons/md";
import { FaBook } from "react-icons/fa";
import { GiRuleBook } from "react-icons/gi";
import { useState } from "react";
import { IoCalendarSharp } from "react-icons/io5";
import { HiDocumentReport } from "react-icons/hi";
import { MdCoPresent } from "react-icons/md";
import { FaRegGrinBeam } from "react-icons/fa";
import { FaMoneyBillWave, FaCalendarTimes, FaClock } from "react-icons/fa";
import { ROLES } from "../../config/roles";
import './sidebar.css';

// Admin ke saare routes
const adminRoutes = [
  {
    path: "/team-chart",
    name: "Hirearchy Chart",
    icon: <HiMiniUserGroup />,
  },
  {
    path: "/user-roles",
    name: "Roles",
    icon: <HiMiniUserGroup />,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: <MdSpaceDashboard />,
    subRoutes: [{ path: "/dept-salary" }]
  },
  {
    path: "/emp-announcements",
    name: "Announcements",
    icon: <GrAnnounce />,
    subRoutes: [{ path: "/add-announcements" }],
  },
  {
    path: "/dept-announcements",
    name: "Depts Announcements",
    icon: <GrAnnounce />,
    subRoutes: [{ path: "/add-dept-announcements" }],
  },
  {
    path: "/handbook",
    name: "HiraLab HandBook",
    icon: <FaBook />,
  },
  {
    path: "/rules",
    name: "HiraLab Rules",
    icon: <GiRuleBook />,
  },
  {
    path: "/departments",
    name: "Departments",
    icon: <HiMiniUserGroup />,
    subRoutes: [{ path: "/add-departments" }],
  },
  {
    path: "/emp-info",
    name: "Employee Information",
    icon: <HiMiniUserGroup />,
    subRoutes: [{ path: "/add-emp" }, { path: "/edit-emp" }],
  },
  {
    path: "/ex-emp-info",
    name: "Ex Employee Information",
    icon: <HiMiniUserGroup />,
  },
  {
    path: "/hr-info",
    name: "HR Information",
    icon: <HiMiniUserGroup />,
    subRoutes: [{ path: "/add-hr" }, { path: "/edit-hr" }],
  },
  {
    path: "/public-holidays",
    name: "Public Holidays",
    icon: <IoCalendarSharp />,
    subRoutes: [{ path: "/add-holiday" }],
  },
  {
    path: "/emps-schedule",
    name: "Employee Schedule",
    icon: <FaClock />,
    subRoutes: [{ path: "/emps-timing" }, { path: "/emp-shift" }, { path: "/edit-timing" }]
  },
  {
    path: "/hr-schedule",
    name: "HR Schedule",
    icon: <FaClock />,
    subRoutes: [{ path: "/hr-timing" }, { path: "/edit-hr-timing" }],
  },
  {
    path: "/emp-payroll",
    name: "Payroll",
    icon: <FaMoneyBillWave />,
    subRoutes: [{ path: "/process-payroll" }, { path: "/payroll-report" }],
  },
  {
    path: "/total-leave",
    name: "Leave",
    icon: <FaCalendarTimes />,
    subRoutes: [
      { path: "/apply-leave" },
      { path: "/approved-leave" },
      { path: "/pending-leave" },
      { path: "/rejected-leave" },
      { path: "/total-leave" },
      { path: "/leave-report" },
      { path: "/emps-leave-report" },
      { path: "/leave" },
      { path: "/edit-leave" },
      { path: "/add-manual-leaves" },
      { path: "/edit-manual-leaves/:userId" }
    ],
  },
  {
    path: "/leave-management",
    name: "Holidays",
    icon: <FaCalendarTimes />,
  },
  {
    path: "/today-report",
    name: "Employee Work Report",
    icon: <HiDocumentReport />,
    subRoutes: [
      { path: "/current-month-work-report" },
      { path: "/all-work-reports" },
    ],
  },
  {
    path: "/basic-salary",
    name: "Employee Benefits",
    icon: <FaRegGrinBeam />,
    subRoutes: [{ path: "/provident-fund" }]
  },
  {
    path: "/current-atd",
    name: "Employee Attandance",
    icon: <MdCoPresent />,
    subRoutes: [
      { path: "/yesterday-atd" },
      { path: "/view-atd" },
      { path: "/all-emps" },
      { path: "/add-atd" },
      { path: "/edit-atd:id" },
      { path: "/current-month-atd" },
    ],
  },
  {
    path: "/bradfactor",
    name: "BradFord Factor",
    icon: <IoCalendarSharp />,
    subRoutes: [
      { path: "/view-bradford" },
      { path: "/all-employee" },
    ],
  },
  {
    path: "/interviewers-data",
    name: "Interviewers Data",
    icon: <IoCalendarSharp />,
    subRoutes: [
      { path: "/add-inteviewees-data" },
    ],
  },
];

// Staff ke routes - 2 items: Attendance & Employee Schedule
// Staff ke routes - Attendance, Employee Schedule, Holidays
const staffRoutes = [
  {
    path: "/current-atd",
    name: "Employee Attandance",
    icon: <MdCoPresent />,
    subRoutes: [
      { path: "/yesterday-atd" },
      { path: "/view-atd" },
      { path: "/all-emps" },
      { path: "/current-month-atd" },
      { path: "/view-atd-day" },
      { path: "/view-absents" },
      { path: "/edit-atd" },
      { path: "/add-atd" },
    ],
  },
  {
    path: "/emps-schedule",
    name: "Employee Schedule",
    icon: <FaClock />,
    subRoutes: [
      { path: "/emps-timing" },
      { path: "/emp-shift" },
      { path: "/edit-timing" },
    ],
  },
  {
    path: "/leave-management",
    name: "Holidays",
    icon: <FaCalendarTimes />,
  },
   {
    path: "/emp-info",
    name: "Employee Information",
    icon: <HiMiniUserGroup />,
    subRoutes: [{ path: "/add-emp" }, { path: "/edit-emp" }],
  },
];

const SideBar = ({ children, employeeName }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const userRole = localStorage.getItem('role');
  const isStaff = userRole === ROLES.STAFF;

  console.log('Sidebar Role Check:', { userRole, isStaff });

  // Role ke hisaab se routes select karo
  const routes = isStaff ? staffRoutes : adminRoutes;

  const toggleSidebar = () => setIsOpen(!isOpen);

  const handleLinkClick = (routePath) => {
    if (routePath === '/interviewers-data') {
      const input = prompt("Enter password to access Interview Data:");
      if (input !== 'your-password') {
        return;
      }
    }
    if (window.innerWidth <= 1024) {
      setIsOpen(false);
    }
  };

  const isActive = (path) => {
    if (path.includes(':')) {
      const basePath = path.split(':')[0];
      return location.pathname.startsWith(basePath);
    }
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const isRouteActive = (route) => {
    if (isActive(route.path)) return true;
    if (route.subRoutes) {
      return route.subRoutes.some(subRoute => {
        if (subRoute.path.includes(':')) {
          const basePath = subRoute.path.split(':')[0];
          return location.pathname.startsWith(basePath);
        }
        return isActive(subRoute.path);
      });
    }
    return false;
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/signin');
  };

  return (
    <>
      <div className="sidebar-container">
        <button className="hamburger" onClick={toggleSidebar}>
          <FaBars />
        </button>
        <div className={`sidebar ${isOpen ? "open" : ""}`}>
          <div className="top_section">
            <h1 className="logo">EMS</h1>
            <small style={{ color: '#888', fontSize: '11px', display: 'block', marginTop: '-5px' }}>
              {isStaff ? 'Staff Portal' : 'Admin Portal'}
            </small>
          </div>
          <section className="routes">
            {routes.map((route, index) => (
              <NavLink
                to={route.path}
                key={index}
                className={`link ${isRouteActive(route) ? 'active' : ''}`}
                onClick={() => handleLinkClick(route.path)}
              >
                <div className="icon">{route.icon}</div>
                <div className={`link_text ${isOpen ? "visible" : "hidden"}`}>
                  {route.name}
                </div>
              </NavLink>
            ))}
          </section>
          <div className="sidebar-footer">
            <span className="employee-name">{employeeName}</span>
            <button className="sign-out" onClick={handleLogout}>
              <FaSignOutAlt />
              {isOpen && "Sign Out"}
            </button>
          </div>
        </div>
      </div>
      <main>{children}</main>
    </>
  );
};

export default SideBar;